import { render, staticRenderFns } from "./SettlementTotalsTable.vue?vue&type=template&id=06e17397&scoped=true"
import script from "./SettlementTotalsTable.vue?vue&type=script&lang=js"
export * from "./SettlementTotalsTable.vue?vue&type=script&lang=js"
import style0 from "./SettlementTotalsTable.vue?vue&type=style&index=0&id=06e17397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e17397",
  null
  
)

export default component.exports